import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import BasicButton from 'components/BasicButton';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { UPGRADE_ACCOUNT_TYPE } from 'constants/upgrade-account-types';
import { ROUTE } from 'constants/route';
import { Role } from 'helpers/user';

const UpgradeAccountButton = props => {
  const { user, history } = props;

  const show = useMemo(() => {
    const isCandidate = Role.isCandidate(user);
    const isRecruiterDefault = Role.isRecruiterDefault(user);
    return (isCandidate || isRecruiterDefault) && !!user.accountUpgradeType;
  }, [user]);

  const handleClickUpgradeAccLink = () => {
    if (UPGRADE_ACCOUNT_TYPE.RECRUITER === user.accountUpgradeType) {
      UpgradeRecruiterAccount();
    } else if (UPGRADE_ACCOUNT_TYPE.CANDIDATE === user.accountUpgradeType) {
      history.push(ROUTE.CANDIDATE_UPGRADE_PREMIUM, {
        returnUrl: history.location.pathname,
      });
    }
  };

  return show ? (
    <div className="sidebar__button">
      <BasicButton
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={600}
        btnText="Upgrade Account"
        btnArrow={true}
        controlFunc={handleClickUpgradeAccLink}
        btnBg="#fff"
        btnHoverBg="#f40"
      />
    </div>
  ) : null;
};

UpgradeAccountButton.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default UpgradeAccountButton;
